export const TABS = {
  IMPORTS: 'imports',
  REQUESTS: 'requests'
};
